// 文章实拍图灯箱:点击 a.ke-media-zoom 弹出大图,支持左右切换/ESC/点击空白关闭
(function () {
  function init() {
    var body = document.querySelector('[data-article-body]');
    if (!body || typeof document.createElement('dialog').showModal !== 'function') return;

    var zooms = Array.prototype.slice.call(body.querySelectorAll('a.ke-media-zoom, .product-photos figure > a, .kd-gallery figure > a'));
    if (!zooms.length) return;

    var article = body.closest('.article-template');
    if (!article) return;

    var dialog = document.createElement('dialog');
    dialog.className = 'ke-lightbox';
    dialog.setAttribute('aria-label', 'Photo viewer');
    dialog.innerHTML =
      '<button type="button" class="ke-lightbox__close" aria-label="Close viewer">&#215;</button>' +
      '<button type="button" class="ke-lightbox__nav ke-lightbox__prev" aria-label="Previous photo">&#8249;</button>' +
      '<button type="button" class="ke-lightbox__nav ke-lightbox__next" aria-label="Next photo">&#8250;</button>' +
      '<p class="ke-lightbox__counter" aria-live="polite"></p>';
    article.appendChild(dialog);

    // 打开前不设置 src,避免空 src 触发当前页请求或渲染裂图
    var img = document.createElement('img');
    img.alt = '';
    dialog.insertBefore(img, dialog.querySelector('.ke-lightbox__next'));
    var counter = dialog.querySelector('.ke-lightbox__counter');
    var prevBtn = dialog.querySelector('.ke-lightbox__prev');
    var nextBtn = dialog.querySelector('.ke-lightbox__next');
    var index = 0;

    if (zooms.length < 2) {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
    }

    function show(i) {
      index = (i + zooms.length) % zooms.length;
      var anchor = zooms[index];
      var thumb = anchor.querySelector('img');
      img.src = anchor.getAttribute('href');
      img.alt = thumb ? thumb.alt : '';
      counter.textContent = (index + 1) + ' / ' + zooms.length;
    }

    zooms.forEach(function (anchor, i) {
      anchor.classList.add('ke-media-zoom');
      anchor.addEventListener('click', function (event) {
        event.preventDefault();
        show(i);
        dialog.showModal();
      });
    });

    dialog.querySelector('.ke-lightbox__close').addEventListener('click', function () {
      dialog.close();
    });
    prevBtn.addEventListener('click', function () { show(index - 1); });
    nextBtn.addEventListener('click', function () { show(index + 1); });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
    document.addEventListener('keydown', function (event) {
      if (!dialog.open) return;
      if (event.key === 'ArrowLeft') show(index - 1);
      if (event.key === 'ArrowRight') show(index + 1);
    });
    dialog.addEventListener('close', function () { img.removeAttribute('src'); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
